import { computed } from 'vue'
import { useAuthStore } from '../stores/auth-store'

export const useAuthPermissions = () => {
  const authStore = useAuthStore()

  const permissions = computed(() => authStore.user?.permissions)
  const canRead = computed(() => permissions.value?.canRead ?? false)
  const canWrite = computed(() => permissions.value?.canWrite ?? false)
  const isAdmin = computed(() => permissions.value?.isAdmin ?? false)
  const isSuperAdmin = computed(() => permissions.value?.isSuperAdmin ?? false)

  return {
    canRead,
    canWrite,
    isAdmin,
    isSuperAdmin,
  }
}
